import React from "react";
import "./index.scss";

import shortNotation from "@/modules/shortNotation";
import { assetImg } from "@/modules/moduleImporter";
import { IKeyNumberDict } from "@/types/GlobalTypes";

interface IProps {
	chipBase: number[];
	betKey: string;
	bets: IKeyNumberDict;
	betOutOfBounds: {[key: string]: boolean};

	//Squeezed between cells
	between?: boolean;

	//Used in mobile
	mobile?: boolean;
}

/**
 * Single chip on the Table component, not on the chip deck.
 */
export default class Chips extends React.Component<IProps> {
	render() {
		const {
			chipBase,
			bets,
			betOutOfBounds,
			between,
			betKey
		} = this.props;

		const totalChipValue = bets[betKey],
			
			isBetOutOfBounds = betOutOfBounds
				? betOutOfBounds[betKey]
				: false,

			visibleChipValue = shortNotation(totalChipValue);

		if (!totalChipValue)
			return null;

		let chipSkin: string;
		for (let a = chipBase.length - 1; a >= 0; a--)
			if (totalChipValue >= chipBase[a]) {
				chipSkin = a + 1 + "_ns";
				break;
			}

		return (
			<div className={"chip-container" +
				(between ? " between" : "") +
				(isBetOutOfBounds ? " out-of-bounds" : "")}>
				<div className={`chip_${chipSkin}`}>
					{ assetImg("chips", chipSkin) }
					<span>
						{visibleChipValue}
					</span>
				</div>
			</div>
		);
	}
}
